module.exports = __webpack_public_path__ + "static/img/2_6_2.f47fd797.jpg";